import React, { useState } from "react";
import { Menu } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import { WifiOutlined, HistoryOutlined } from "@ant-design/icons";

const menuItems = [
  {
    label: "Speed Test",
    key: "/",
    icon: <WifiOutlined />,
  },
  {
    label: "Results History",
    key: "/history",
    icon: <HistoryOutlined />,
  },
];

const Navigation = () => {
  const location = useLocation();
  const [current, setCurrent] = useState(location.pathname);
  const navigate = useNavigate();

  const onClick = (e) => {
    setCurrent(e.key);
    navigate(e.key);
  };

  return (
    <Menu
      onClick={onClick}
      selectedKeys={[current]}
      mode="horizontal"
      items={menuItems}
      style={{ borderBottom: "none" }}
    />
  );
};

export default Navigation;
